/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from "@tanstack/react-router";

// Import Routes

import { Route as rootRoute } from "./routes/__root";
import { Route as RootRouteImport } from "./routes/_root/route";
import { Route as AuthenticatedRouteImport } from "./routes/_authenticated/route";
import { Route as AuthenticatedDashboardImport } from "./routes/_authenticated/dashboard";
import { Route as authTotpSetupImport } from "./routes/(auth)/totp-setup";
import { Route as authSignInImport } from "./routes/(auth)/sign-in";
import { Route as authOtpImport } from "./routes/(auth)/otp";
import { Route as authNewPasswordImport } from "./routes/(auth)/new-password";
import { Route as auth500Import } from "./routes/(auth)/500";
import { Route as RootRootUserIndexImport } from "./routes/_root/root-user/index";
import { Route as AuthenticatedUsersIndexImport } from "./routes/_authenticated/users/index";
import { Route as RootRootUserAuditImport } from "./routes/_root/root-user/audit";
import { Route as rootRootUserTotpSetupImport } from "./routes/(root)/root-user/totp-setup";
import { Route as rootRootUserOtpImport } from "./routes/(root)/root-user/otp";
import { Route as rootRootUserNewPasswordImport } from "./routes/(root)/root-user/new-password";
import { Route as rootRootUserLoginImport } from "./routes/(root)/root-user/login";
import { Route as RootRootUserSettingsRouteImport } from "./routes/_root/root-user/settings/route";
import { Route as RootRootUserUserIndexImport } from "./routes/_root/root-user/user/index";
import { Route as RootRootUserOrganizationIndexImport } from "./routes/_root/root-user/organization/index";
import { Route as RootRootUserDashboardIndexImport } from "./routes/_root/root-user/dashboard/index";
import { Route as RootRootUserSettingsProfileImport } from "./routes/_root/root-user/settings/profile";
import { Route as RootRootUserSettingsAppearanceImport } from "./routes/_root/root-user/settings/appearance";
import { Route as RootRootUserOrganizationCreateOrganizationImport } from "./routes/_root/root-user/organization/create-organization";
import { Route as RootRootUserDashboardLeadAnalyticsImport } from "./routes/_root/root-user/dashboard/lead-analytics";
import { Route as RootRootUserDashboardAnalyticsImport } from "./routes/_root/root-user/dashboard/analytics";
import { Route as RootRootUserCustomerLeadsManagementImport } from "./routes/_root/root-user/customer/leads-management";
import { Route as RootRootUserCustomerLeadsImport } from "./routes/_root/root-user/customer/leads";
import { Route as RootRootUserCustomerContactsImport } from "./routes/_root/root-user/customer/contacts";
import { Route as RootRootUserOrganizationOrganizationIdUpdateImport } from "./routes/_root/root-user/organization/organization.$id.update";
import { Route as RootRootUserOrganizationOrganizationIdDetailImport } from "./routes/_root/root-user/organization/organization.$id.detail";

// Create Virtual Routes

const errors503LazyImport = createFileRoute("/(errors)/503")();
const errors500LazyImport = createFileRoute("/(errors)/500")();
const errors404LazyImport = createFileRoute("/(errors)/404")();
const errors403LazyImport = createFileRoute("/(errors)/403")();
const errors401LazyImport = createFileRoute("/(errors)/401")();
const authSignUpLazyImport = createFileRoute("/(auth)/sign-up")();
const authSignIn2LazyImport = createFileRoute("/(auth)/sign-in-2")();
const authForgotPasswordLazyImport = createFileRoute(
  "/(auth)/forgot-password",
)();
const AuthenticatedSettingsRouteLazyImport = createFileRoute(
  "/_authenticated/settings",
)();
const AuthenticatedHelpCenterIndexLazyImport = createFileRoute(
  "/_authenticated/help-center/",
)();
const AuthenticatedUsersCreateUserLazyImport = createFileRoute(
  "/_authenticated/users/create-user",
)();
const AuthenticatedSettingsProfileLazyImport = createFileRoute(
  "/_authenticated/settings/profile",
)();
const AuthenticatedSettingsNotificationsLazyImport = createFileRoute(
  "/_authenticated/settings/notifications",
)();
const AuthenticatedSettingsDisplayLazyImport = createFileRoute(
  "/_authenticated/settings/display",
)();
const AuthenticatedSettingsAppearanceLazyImport = createFileRoute(
  "/_authenticated/settings/appearance",
)();
const AuthenticatedSettingsAccountLazyImport = createFileRoute(
  "/_authenticated/settings/account",
)();
const AuthenticatedUsersUserIdLazyImport = createFileRoute(
  "/_authenticated/users/user/$id",
)();

// Create/Update Routes

const RootRouteRoute = RootRouteImport.update({
  id: "/_root",
  getParentRoute: () => rootRoute,
} as any);

const AuthenticatedRouteRoute = AuthenticatedRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRoute,
} as any);

const errors503LazyRoute = errors503LazyImport
  .update({
    id: "/(errors)/503",
    path: "/503",
    getParentRoute: () => rootRoute,
  } as any)
  .lazy(() => import("./routes/(errors)/503.lazy").then((d) => d.Route));

const errors500LazyRoute = errors500LazyImport
  .update({
    id: "/(errors)/500",
    path: "/500",
    getParentRoute: () => rootRoute,
  } as any)
  .lazy(() => import("./routes/(errors)/500.lazy").then((d) => d.Route));

const errors404LazyRoute = errors404LazyImport
  .update({
    id: "/(errors)/404",
    path: "/404",
    getParentRoute: () => rootRoute,
  } as any)
  .lazy(() => import("./routes/(errors)/404.lazy").then((d) => d.Route));

const errors403LazyRoute = errors403LazyImport
  .update({
    id: "/(errors)/403",
    path: "/403",
    getParentRoute: () => rootRoute,
  } as any)
  .lazy(() => import("./routes/(errors)/403.lazy").then((d) => d.Route));

const errors401LazyRoute = errors401LazyImport
  .update({
    id: "/(errors)/401",
    path: "/401",
    getParentRoute: () => rootRoute,
  } as any)
  .lazy(() => import("./routes/(errors)/401.lazy").then((d) => d.Route));

const authSignUpLazyRoute = authSignUpLazyImport
  .update({
    id: "/(auth)/sign-up",
    path: "/sign-up",
    getParentRoute: () => rootRoute,
  } as any)
  .lazy(() => import("./routes/(auth)/sign-up.lazy").then((d) => d.Route));

const authSignIn2LazyRoute = authSignIn2LazyImport
  .update({
    id: "/(auth)/sign-in-2",
    path: "/sign-in-2",
    getParentRoute: () => rootRoute,
  } as any)
  .lazy(() => import("./routes/(auth)/sign-in-2.lazy").then((d) => d.Route));

const authForgotPasswordLazyRoute = authForgotPasswordLazyImport
  .update({
    id: "/(auth)/forgot-password",
    path: "/forgot-password",
    getParentRoute: () => rootRoute,
  } as any)
  .lazy(() =>
    import("./routes/(auth)/forgot-password.lazy").then((d) => d.Route),
  );

const AuthenticatedSettingsRouteLazyRoute =
  AuthenticatedSettingsRouteLazyImport.update({
    id: "/settings",
    path: "/settings",
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import("./routes/_authenticated/settings/route.lazy").then((d) => d.Route),
  );

const AuthenticatedDashboardRoute = AuthenticatedDashboardImport.update({
  id: "/dashboard",
  path: "/dashboard",
  getParentRoute: () => AuthenticatedRouteRoute,
} as any);

const authTotpSetupRoute = authTotpSetupImport.update({
  id: "/(auth)/totp-setup",
  path: "/totp-setup",
  getParentRoute: () => rootRoute,
} as any);

const authSignInRoute = authSignInImport.update({
  id: "/(auth)/sign-in",
  path: "/sign-in",
  getParentRoute: () => rootRoute,
} as any);

const authOtpRoute = authOtpImport.update({
  id: "/(auth)/otp",
  path: "/otp",
  getParentRoute: () => rootRoute,
} as any);

const authNewPasswordRoute = authNewPasswordImport.update({
  id: "/(auth)/new-password",
  path: "/new-password",
  getParentRoute: () => rootRoute,
} as any);

const auth500Route = auth500Import.update({
  id: "/(auth)/500",
  path: "/500",
  getParentRoute: () => rootRoute,
} as any);

const AuthenticatedHelpCenterIndexLazyRoute =
  AuthenticatedHelpCenterIndexLazyImport.update({
    id: "/help-center/",
    path: "/help-center/",
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import("./routes/_authenticated/help-center/index.lazy").then(
      (d) => d.Route,
    ),
  );

const RootRootUserIndexRoute = RootRootUserIndexImport.update({
  id: "/root-user/",
  path: "/root-user/",
  getParentRoute: () => RootRouteRoute,
} as any);

const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexImport.update({
  id: "/users/",
  path: "/users/",
  getParentRoute: () => AuthenticatedRouteRoute,
} as any);

const AuthenticatedUsersCreateUserLazyRoute =
  AuthenticatedUsersCreateUserLazyImport.update({
    id: "/users/create-user",
    path: "/users/create-user",
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import("./routes/_authenticated/users/create-user.lazy").then(
      (d) => d.Route,
    ),
  );

const AuthenticatedSettingsProfileLazyRoute =
  AuthenticatedSettingsProfileLazyImport.update({
    id: "/profile",
    path: "/profile",
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import("./routes/_authenticated/settings/profile.lazy").then(
      (d) => d.Route,
    ),
  );

const AuthenticatedSettingsNotificationsLazyRoute =
  AuthenticatedSettingsNotificationsLazyImport.update({
    id: "/notifications",
    path: "/notifications",
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import("./routes/_authenticated/settings/notifications.lazy").then(
      (d) => d.Route,
    ),
  );

const AuthenticatedSettingsDisplayLazyRoute =
  AuthenticatedSettingsDisplayLazyImport.update({
    id: "/display",
    path: "/display",
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import("./routes/_authenticated/settings/display.lazy").then(
      (d) => d.Route,
    ),
  );

const AuthenticatedSettingsAppearanceLazyRoute =
  AuthenticatedSettingsAppearanceLazyImport.update({
    id: "/appearance",
    path: "/appearance",
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import("./routes/_authenticated/settings/appearance.lazy").then(
      (d) => d.Route,
    ),
  );

const AuthenticatedSettingsAccountLazyRoute =
  AuthenticatedSettingsAccountLazyImport.update({
    id: "/account",
    path: "/account",
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import("./routes/_authenticated/settings/account.lazy").then(
      (d) => d.Route,
    ),
  );

const RootRootUserAuditRoute = RootRootUserAuditImport.update({
  id: "/root-user/audit",
  path: "/root-user/audit",
  getParentRoute: () => RootRouteRoute,
} as any);

const rootRootUserTotpSetupRoute = rootRootUserTotpSetupImport.update({
  id: "/(root)/root-user/totp-setup",
  path: "/root-user/totp-setup",
  getParentRoute: () => rootRoute,
} as any);

const rootRootUserOtpRoute = rootRootUserOtpImport.update({
  id: "/(root)/root-user/otp",
  path: "/root-user/otp",
  getParentRoute: () => rootRoute,
} as any);

const rootRootUserNewPasswordRoute = rootRootUserNewPasswordImport.update({
  id: "/(root)/root-user/new-password",
  path: "/root-user/new-password",
  getParentRoute: () => rootRoute,
} as any);

const rootRootUserLoginRoute = rootRootUserLoginImport.update({
  id: "/(root)/root-user/login",
  path: "/root-user/login",
  getParentRoute: () => rootRoute,
} as any);

const RootRootUserSettingsRouteRoute = RootRootUserSettingsRouteImport.update({
  id: "/root-user/settings",
  path: "/root-user/settings",
  getParentRoute: () => RootRouteRoute,
} as any);

const RootRootUserUserIndexRoute = RootRootUserUserIndexImport.update({
  id: "/root-user/user/",
  path: "/root-user/user/",
  getParentRoute: () => RootRouteRoute,
} as any);

const RootRootUserOrganizationIndexRoute =
  RootRootUserOrganizationIndexImport.update({
    id: "/root-user/organization/",
    path: "/root-user/organization/",
    getParentRoute: () => RootRouteRoute,
  } as any);

const RootRootUserDashboardIndexRoute = RootRootUserDashboardIndexImport.update(
  {
    id: "/root-user/dashboard/",
    path: "/root-user/dashboard/",
    getParentRoute: () => RootRouteRoute,
  } as any,
);

const AuthenticatedUsersUserIdLazyRoute =
  AuthenticatedUsersUserIdLazyImport.update({
    id: "/users/user/$id",
    path: "/users/user/$id",
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import("./routes/_authenticated/users/user.$id.lazy").then((d) => d.Route),
  );

const RootRootUserSettingsProfileRoute =
  RootRootUserSettingsProfileImport.update({
    id: "/profile",
    path: "/profile",
    getParentRoute: () => RootRootUserSettingsRouteRoute,
  } as any);

const RootRootUserSettingsAppearanceRoute =
  RootRootUserSettingsAppearanceImport.update({
    id: "/appearance",
    path: "/appearance",
    getParentRoute: () => RootRootUserSettingsRouteRoute,
  } as any);

const RootRootUserOrganizationCreateOrganizationRoute =
  RootRootUserOrganizationCreateOrganizationImport.update({
    id: "/root-user/organization/create-organization",
    path: "/root-user/organization/create-organization",
    getParentRoute: () => RootRouteRoute,
  } as any);

const RootRootUserDashboardLeadAnalyticsRoute =
  RootRootUserDashboardLeadAnalyticsImport.update({
    id: "/root-user/dashboard/lead-analytics",
    path: "/root-user/dashboard/lead-analytics",
    getParentRoute: () => RootRouteRoute,
  } as any);

const RootRootUserDashboardAnalyticsRoute =
  RootRootUserDashboardAnalyticsImport.update({
    id: "/root-user/dashboard/analytics",
    path: "/root-user/dashboard/analytics",
    getParentRoute: () => RootRouteRoute,
  } as any);

const RootRootUserCustomerLeadsManagementRoute =
  RootRootUserCustomerLeadsManagementImport.update({
    id: "/root-user/customer/leads-management",
    path: "/root-user/customer/leads-management",
    getParentRoute: () => RootRouteRoute,
  } as any);

const RootRootUserCustomerLeadsRoute = RootRootUserCustomerLeadsImport.update({
  id: "/root-user/customer/leads",
  path: "/root-user/customer/leads",
  getParentRoute: () => RootRouteRoute,
} as any);

const RootRootUserCustomerContactsRoute =
  RootRootUserCustomerContactsImport.update({
    id: "/root-user/customer/contacts",
    path: "/root-user/customer/contacts",
    getParentRoute: () => RootRouteRoute,
  } as any);

const RootRootUserOrganizationOrganizationIdUpdateRoute =
  RootRootUserOrganizationOrganizationIdUpdateImport.update({
    id: "/root-user/organization/organization/$id/update",
    path: "/root-user/organization/organization/$id/update",
    getParentRoute: () => RootRouteRoute,
  } as any);

const RootRootUserOrganizationOrganizationIdDetailRoute =
  RootRootUserOrganizationOrganizationIdDetailImport.update({
    id: "/root-user/organization/organization/$id/detail",
    path: "/root-user/organization/organization/$id/detail",
    getParentRoute: () => RootRouteRoute,
  } as any);

// Populate the FileRoutesByPath interface

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_authenticated": {
      id: "/_authenticated";
      path: "";
      fullPath: "";
      preLoaderRoute: typeof AuthenticatedRouteImport;
      parentRoute: typeof rootRoute;
    };
    "/_root": {
      id: "/_root";
      path: "";
      fullPath: "";
      preLoaderRoute: typeof RootRouteImport;
      parentRoute: typeof rootRoute;
    };
    "/(auth)/500": {
      id: "/(auth)/500";
      path: "/500";
      fullPath: "/500";
      preLoaderRoute: typeof auth500Import;
      parentRoute: typeof rootRoute;
    };
    "/(auth)/new-password": {
      id: "/(auth)/new-password";
      path: "/new-password";
      fullPath: "/new-password";
      preLoaderRoute: typeof authNewPasswordImport;
      parentRoute: typeof rootRoute;
    };
    "/(auth)/otp": {
      id: "/(auth)/otp";
      path: "/otp";
      fullPath: "/otp";
      preLoaderRoute: typeof authOtpImport;
      parentRoute: typeof rootRoute;
    };
    "/(auth)/sign-in": {
      id: "/(auth)/sign-in";
      path: "/sign-in";
      fullPath: "/sign-in";
      preLoaderRoute: typeof authSignInImport;
      parentRoute: typeof rootRoute;
    };
    "/(auth)/totp-setup": {
      id: "/(auth)/totp-setup";
      path: "/totp-setup";
      fullPath: "/totp-setup";
      preLoaderRoute: typeof authTotpSetupImport;
      parentRoute: typeof rootRoute;
    };
    "/_authenticated/dashboard": {
      id: "/_authenticated/dashboard";
      path: "/dashboard";
      fullPath: "/dashboard";
      preLoaderRoute: typeof AuthenticatedDashboardImport;
      parentRoute: typeof AuthenticatedRouteImport;
    };
    "/_authenticated/settings": {
      id: "/_authenticated/settings";
      path: "/settings";
      fullPath: "/settings";
      preLoaderRoute: typeof AuthenticatedSettingsRouteLazyImport;
      parentRoute: typeof AuthenticatedRouteImport;
    };
    "/(auth)/forgot-password": {
      id: "/(auth)/forgot-password";
      path: "/forgot-password";
      fullPath: "/forgot-password";
      preLoaderRoute: typeof authForgotPasswordLazyImport;
      parentRoute: typeof rootRoute;
    };
    "/(auth)/sign-in-2": {
      id: "/(auth)/sign-in-2";
      path: "/sign-in-2";
      fullPath: "/sign-in-2";
      preLoaderRoute: typeof authSignIn2LazyImport;
      parentRoute: typeof rootRoute;
    };
    "/(auth)/sign-up": {
      id: "/(auth)/sign-up";
      path: "/sign-up";
      fullPath: "/sign-up";
      preLoaderRoute: typeof authSignUpLazyImport;
      parentRoute: typeof rootRoute;
    };
    "/(errors)/401": {
      id: "/(errors)/401";
      path: "/401";
      fullPath: "/401";
      preLoaderRoute: typeof errors401LazyImport;
      parentRoute: typeof rootRoute;
    };
    "/(errors)/403": {
      id: "/(errors)/403";
      path: "/403";
      fullPath: "/403";
      preLoaderRoute: typeof errors403LazyImport;
      parentRoute: typeof rootRoute;
    };
    "/(errors)/404": {
      id: "/(errors)/404";
      path: "/404";
      fullPath: "/404";
      preLoaderRoute: typeof errors404LazyImport;
      parentRoute: typeof rootRoute;
    };
    "/(errors)/500": {
      id: "/(errors)/500";
      path: "/500";
      fullPath: "/500";
      preLoaderRoute: typeof errors500LazyImport;
      parentRoute: typeof rootRoute;
    };
    "/(errors)/503": {
      id: "/(errors)/503";
      path: "/503";
      fullPath: "/503";
      preLoaderRoute: typeof errors503LazyImport;
      parentRoute: typeof rootRoute;
    };
    "/_root/root-user/settings": {
      id: "/_root/root-user/settings";
      path: "/root-user/settings";
      fullPath: "/root-user/settings";
      preLoaderRoute: typeof RootRootUserSettingsRouteImport;
      parentRoute: typeof RootRouteImport;
    };
    "/(root)/root-user/login": {
      id: "/(root)/root-user/login";
      path: "/root-user/login";
      fullPath: "/root-user/login";
      preLoaderRoute: typeof rootRootUserLoginImport;
      parentRoute: typeof rootRoute;
    };
    "/(root)/root-user/new-password": {
      id: "/(root)/root-user/new-password";
      path: "/root-user/new-password";
      fullPath: "/root-user/new-password";
      preLoaderRoute: typeof rootRootUserNewPasswordImport;
      parentRoute: typeof rootRoute;
    };
    "/(root)/root-user/otp": {
      id: "/(root)/root-user/otp";
      path: "/root-user/otp";
      fullPath: "/root-user/otp";
      preLoaderRoute: typeof rootRootUserOtpImport;
      parentRoute: typeof rootRoute;
    };
    "/(root)/root-user/totp-setup": {
      id: "/(root)/root-user/totp-setup";
      path: "/root-user/totp-setup";
      fullPath: "/root-user/totp-setup";
      preLoaderRoute: typeof rootRootUserTotpSetupImport;
      parentRoute: typeof rootRoute;
    };
    "/_root/root-user/audit": {
      id: "/_root/root-user/audit";
      path: "/root-user/audit";
      fullPath: "/root-user/audit";
      preLoaderRoute: typeof RootRootUserAuditImport;
      parentRoute: typeof RootRouteImport;
    };
    "/_authenticated/settings/account": {
      id: "/_authenticated/settings/account";
      path: "/account";
      fullPath: "/settings/account";
      preLoaderRoute: typeof AuthenticatedSettingsAccountLazyImport;
      parentRoute: typeof AuthenticatedSettingsRouteLazyImport;
    };
    "/_authenticated/settings/appearance": {
      id: "/_authenticated/settings/appearance";
      path: "/appearance";
      fullPath: "/settings/appearance";
      preLoaderRoute: typeof AuthenticatedSettingsAppearanceLazyImport;
      parentRoute: typeof AuthenticatedSettingsRouteLazyImport;
    };
    "/_authenticated/settings/display": {
      id: "/_authenticated/settings/display";
      path: "/display";
      fullPath: "/settings/display";
      preLoaderRoute: typeof AuthenticatedSettingsDisplayLazyImport;
      parentRoute: typeof AuthenticatedSettingsRouteLazyImport;
    };
    "/_authenticated/settings/notifications": {
      id: "/_authenticated/settings/notifications";
      path: "/notifications";
      fullPath: "/settings/notifications";
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsLazyImport;
      parentRoute: typeof AuthenticatedSettingsRouteLazyImport;
    };
    "/_authenticated/settings/profile": {
      id: "/_authenticated/settings/profile";
      path: "/profile";
      fullPath: "/settings/profile";
      preLoaderRoute: typeof AuthenticatedSettingsProfileLazyImport;
      parentRoute: typeof AuthenticatedSettingsRouteLazyImport;
    };
    "/_authenticated/users/create-user": {
      id: "/_authenticated/users/create-user";
      path: "/users/create-user";
      fullPath: "/users/create-user";
      preLoaderRoute: typeof AuthenticatedUsersCreateUserLazyImport;
      parentRoute: typeof AuthenticatedRouteImport;
    };
    "/_authenticated/users/": {
      id: "/_authenticated/users/";
      path: "/users";
      fullPath: "/users";
      preLoaderRoute: typeof AuthenticatedUsersIndexImport;
      parentRoute: typeof AuthenticatedRouteImport;
    };
    "/_root/root-user/": {
      id: "/_root/root-user/";
      path: "/root-user";
      fullPath: "/root-user";
      preLoaderRoute: typeof RootRootUserIndexImport;
      parentRoute: typeof RootRouteImport;
    };
    "/_authenticated/help-center/": {
      id: "/_authenticated/help-center/";
      path: "/help-center";
      fullPath: "/help-center";
      preLoaderRoute: typeof AuthenticatedHelpCenterIndexLazyImport;
      parentRoute: typeof AuthenticatedRouteImport;
    };
    "/_root/root-user/customer/contacts": {
      id: "/_root/root-user/customer/contacts";
      path: "/root-user/customer/contacts";
      fullPath: "/root-user/customer/contacts";
      preLoaderRoute: typeof RootRootUserCustomerContactsImport;
      parentRoute: typeof RootRouteImport;
    };
    "/_root/root-user/customer/leads": {
      id: "/_root/root-user/customer/leads";
      path: "/root-user/customer/leads";
      fullPath: "/root-user/customer/leads";
      preLoaderRoute: typeof RootRootUserCustomerLeadsImport;
      parentRoute: typeof RootRouteImport;
    };
    "/_root/root-user/customer/leads-management": {
      id: "/_root/root-user/customer/leads-management";
      path: "/root-user/customer/leads-management";
      fullPath: "/root-user/customer/leads-management";
      preLoaderRoute: typeof RootRootUserCustomerLeadsManagementImport;
      parentRoute: typeof RootRouteImport;
    };
    "/_root/root-user/dashboard/analytics": {
      id: "/_root/root-user/dashboard/analytics";
      path: "/root-user/dashboard/analytics";
      fullPath: "/root-user/dashboard/analytics";
      preLoaderRoute: typeof RootRootUserDashboardAnalyticsImport;
      parentRoute: typeof RootRouteImport;
    };
    "/_root/root-user/dashboard/lead-analytics": {
      id: "/_root/root-user/dashboard/lead-analytics";
      path: "/root-user/dashboard/lead-analytics";
      fullPath: "/root-user/dashboard/lead-analytics";
      preLoaderRoute: typeof RootRootUserDashboardLeadAnalyticsImport;
      parentRoute: typeof RootRouteImport;
    };
    "/_root/root-user/organization/create-organization": {
      id: "/_root/root-user/organization/create-organization";
      path: "/root-user/organization/create-organization";
      fullPath: "/root-user/organization/create-organization";
      preLoaderRoute: typeof RootRootUserOrganizationCreateOrganizationImport;
      parentRoute: typeof RootRouteImport;
    };
    "/_root/root-user/settings/appearance": {
      id: "/_root/root-user/settings/appearance";
      path: "/appearance";
      fullPath: "/root-user/settings/appearance";
      preLoaderRoute: typeof RootRootUserSettingsAppearanceImport;
      parentRoute: typeof RootRootUserSettingsRouteImport;
    };
    "/_root/root-user/settings/profile": {
      id: "/_root/root-user/settings/profile";
      path: "/profile";
      fullPath: "/root-user/settings/profile";
      preLoaderRoute: typeof RootRootUserSettingsProfileImport;
      parentRoute: typeof RootRootUserSettingsRouteImport;
    };
    "/_authenticated/users/user/$id": {
      id: "/_authenticated/users/user/$id";
      path: "/users/user/$id";
      fullPath: "/users/user/$id";
      preLoaderRoute: typeof AuthenticatedUsersUserIdLazyImport;
      parentRoute: typeof AuthenticatedRouteImport;
    };
    "/_root/root-user/dashboard/": {
      id: "/_root/root-user/dashboard/";
      path: "/root-user/dashboard";
      fullPath: "/root-user/dashboard";
      preLoaderRoute: typeof RootRootUserDashboardIndexImport;
      parentRoute: typeof RootRouteImport;
    };
    "/_root/root-user/organization/": {
      id: "/_root/root-user/organization/";
      path: "/root-user/organization";
      fullPath: "/root-user/organization";
      preLoaderRoute: typeof RootRootUserOrganizationIndexImport;
      parentRoute: typeof RootRouteImport;
    };
    "/_root/root-user/user/": {
      id: "/_root/root-user/user/";
      path: "/root-user/user";
      fullPath: "/root-user/user";
      preLoaderRoute: typeof RootRootUserUserIndexImport;
      parentRoute: typeof RootRouteImport;
    };
    "/_root/root-user/organization/organization/$id/detail": {
      id: "/_root/root-user/organization/organization/$id/detail";
      path: "/root-user/organization/organization/$id/detail";
      fullPath: "/root-user/organization/organization/$id/detail";
      preLoaderRoute: typeof RootRootUserOrganizationOrganizationIdDetailImport;
      parentRoute: typeof RootRouteImport;
    };
    "/_root/root-user/organization/organization/$id/update": {
      id: "/_root/root-user/organization/organization/$id/update";
      path: "/root-user/organization/organization/$id/update";
      fullPath: "/root-user/organization/organization/$id/update";
      preLoaderRoute: typeof RootRootUserOrganizationOrganizationIdUpdateImport;
      parentRoute: typeof RootRouteImport;
    };
  }
}

// Create and export the route tree

interface AuthenticatedSettingsRouteLazyRouteChildren {
  AuthenticatedSettingsAccountLazyRoute: typeof AuthenticatedSettingsAccountLazyRoute;
  AuthenticatedSettingsAppearanceLazyRoute: typeof AuthenticatedSettingsAppearanceLazyRoute;
  AuthenticatedSettingsDisplayLazyRoute: typeof AuthenticatedSettingsDisplayLazyRoute;
  AuthenticatedSettingsNotificationsLazyRoute: typeof AuthenticatedSettingsNotificationsLazyRoute;
  AuthenticatedSettingsProfileLazyRoute: typeof AuthenticatedSettingsProfileLazyRoute;
}

const AuthenticatedSettingsRouteLazyRouteChildren: AuthenticatedSettingsRouteLazyRouteChildren =
  {
    AuthenticatedSettingsAccountLazyRoute:
      AuthenticatedSettingsAccountLazyRoute,
    AuthenticatedSettingsAppearanceLazyRoute:
      AuthenticatedSettingsAppearanceLazyRoute,
    AuthenticatedSettingsDisplayLazyRoute:
      AuthenticatedSettingsDisplayLazyRoute,
    AuthenticatedSettingsNotificationsLazyRoute:
      AuthenticatedSettingsNotificationsLazyRoute,
    AuthenticatedSettingsProfileLazyRoute:
      AuthenticatedSettingsProfileLazyRoute,
  };

const AuthenticatedSettingsRouteLazyRouteWithChildren =
  AuthenticatedSettingsRouteLazyRoute._addFileChildren(
    AuthenticatedSettingsRouteLazyRouteChildren,
  );

interface AuthenticatedRouteRouteChildren {
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute;
  AuthenticatedSettingsRouteLazyRoute: typeof AuthenticatedSettingsRouteLazyRouteWithChildren;
  AuthenticatedUsersCreateUserLazyRoute: typeof AuthenticatedUsersCreateUserLazyRoute;
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute;
  AuthenticatedHelpCenterIndexLazyRoute: typeof AuthenticatedHelpCenterIndexLazyRoute;
  AuthenticatedUsersUserIdLazyRoute: typeof AuthenticatedUsersUserIdLazyRoute;
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedSettingsRouteLazyRoute:
    AuthenticatedSettingsRouteLazyRouteWithChildren,
  AuthenticatedUsersCreateUserLazyRoute: AuthenticatedUsersCreateUserLazyRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedHelpCenterIndexLazyRoute: AuthenticatedHelpCenterIndexLazyRoute,
  AuthenticatedUsersUserIdLazyRoute: AuthenticatedUsersUserIdLazyRoute,
};

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren);

interface RootRootUserSettingsRouteRouteChildren {
  RootRootUserSettingsAppearanceRoute: typeof RootRootUserSettingsAppearanceRoute;
  RootRootUserSettingsProfileRoute: typeof RootRootUserSettingsProfileRoute;
}

const RootRootUserSettingsRouteRouteChildren: RootRootUserSettingsRouteRouteChildren =
  {
    RootRootUserSettingsAppearanceRoute: RootRootUserSettingsAppearanceRoute,
    RootRootUserSettingsProfileRoute: RootRootUserSettingsProfileRoute,
  };

const RootRootUserSettingsRouteRouteWithChildren =
  RootRootUserSettingsRouteRoute._addFileChildren(
    RootRootUserSettingsRouteRouteChildren,
  );

interface RootRouteRouteChildren {
  RootRootUserSettingsRouteRoute: typeof RootRootUserSettingsRouteRouteWithChildren;
  RootRootUserAuditRoute: typeof RootRootUserAuditRoute;
  RootRootUserIndexRoute: typeof RootRootUserIndexRoute;
  RootRootUserCustomerContactsRoute: typeof RootRootUserCustomerContactsRoute;
  RootRootUserCustomerLeadsRoute: typeof RootRootUserCustomerLeadsRoute;
  RootRootUserCustomerLeadsManagementRoute: typeof RootRootUserCustomerLeadsManagementRoute;
  RootRootUserDashboardAnalyticsRoute: typeof RootRootUserDashboardAnalyticsRoute;
  RootRootUserDashboardLeadAnalyticsRoute: typeof RootRootUserDashboardLeadAnalyticsRoute;
  RootRootUserOrganizationCreateOrganizationRoute: typeof RootRootUserOrganizationCreateOrganizationRoute;
  RootRootUserDashboardIndexRoute: typeof RootRootUserDashboardIndexRoute;
  RootRootUserOrganizationIndexRoute: typeof RootRootUserOrganizationIndexRoute;
  RootRootUserUserIndexRoute: typeof RootRootUserUserIndexRoute;
  RootRootUserOrganizationOrganizationIdDetailRoute: typeof RootRootUserOrganizationOrganizationIdDetailRoute;
  RootRootUserOrganizationOrganizationIdUpdateRoute: typeof RootRootUserOrganizationOrganizationIdUpdateRoute;
}

const RootRouteRouteChildren: RootRouteRouteChildren = {
  RootRootUserSettingsRouteRoute: RootRootUserSettingsRouteRouteWithChildren,
  RootRootUserAuditRoute: RootRootUserAuditRoute,
  RootRootUserIndexRoute: RootRootUserIndexRoute,
  RootRootUserCustomerContactsRoute: RootRootUserCustomerContactsRoute,
  RootRootUserCustomerLeadsRoute: RootRootUserCustomerLeadsRoute,
  RootRootUserCustomerLeadsManagementRoute:
    RootRootUserCustomerLeadsManagementRoute,
  RootRootUserDashboardAnalyticsRoute: RootRootUserDashboardAnalyticsRoute,
  RootRootUserDashboardLeadAnalyticsRoute:
    RootRootUserDashboardLeadAnalyticsRoute,
  RootRootUserOrganizationCreateOrganizationRoute:
    RootRootUserOrganizationCreateOrganizationRoute,
  RootRootUserDashboardIndexRoute: RootRootUserDashboardIndexRoute,
  RootRootUserOrganizationIndexRoute: RootRootUserOrganizationIndexRoute,
  RootRootUserUserIndexRoute: RootRootUserUserIndexRoute,
  RootRootUserOrganizationOrganizationIdDetailRoute:
    RootRootUserOrganizationOrganizationIdDetailRoute,
  RootRootUserOrganizationOrganizationIdUpdateRoute:
    RootRootUserOrganizationOrganizationIdUpdateRoute,
};

const RootRouteRouteWithChildren = RootRouteRoute._addFileChildren(
  RootRouteRouteChildren,
);

export interface FileRoutesByFullPath {
  "": typeof RootRouteRouteWithChildren;
  "/500": typeof errors500LazyRoute;
  "/new-password": typeof authNewPasswordRoute;
  "/otp": typeof authOtpRoute;
  "/sign-in": typeof authSignInRoute;
  "/totp-setup": typeof authTotpSetupRoute;
  "/dashboard": typeof AuthenticatedDashboardRoute;
  "/settings": typeof AuthenticatedSettingsRouteLazyRouteWithChildren;
  "/forgot-password": typeof authForgotPasswordLazyRoute;
  "/sign-in-2": typeof authSignIn2LazyRoute;
  "/sign-up": typeof authSignUpLazyRoute;
  "/401": typeof errors401LazyRoute;
  "/403": typeof errors403LazyRoute;
  "/404": typeof errors404LazyRoute;
  "/503": typeof errors503LazyRoute;
  "/root-user/settings": typeof RootRootUserSettingsRouteRouteWithChildren;
  "/root-user/login": typeof rootRootUserLoginRoute;
  "/root-user/new-password": typeof rootRootUserNewPasswordRoute;
  "/root-user/otp": typeof rootRootUserOtpRoute;
  "/root-user/totp-setup": typeof rootRootUserTotpSetupRoute;
  "/root-user/audit": typeof RootRootUserAuditRoute;
  "/settings/account": typeof AuthenticatedSettingsAccountLazyRoute;
  "/settings/appearance": typeof AuthenticatedSettingsAppearanceLazyRoute;
  "/settings/display": typeof AuthenticatedSettingsDisplayLazyRoute;
  "/settings/notifications": typeof AuthenticatedSettingsNotificationsLazyRoute;
  "/settings/profile": typeof AuthenticatedSettingsProfileLazyRoute;
  "/users/create-user": typeof AuthenticatedUsersCreateUserLazyRoute;
  "/users": typeof AuthenticatedUsersIndexRoute;
  "/root-user": typeof RootRootUserIndexRoute;
  "/help-center": typeof AuthenticatedHelpCenterIndexLazyRoute;
  "/root-user/customer/contacts": typeof RootRootUserCustomerContactsRoute;
  "/root-user/customer/leads": typeof RootRootUserCustomerLeadsRoute;
  "/root-user/customer/leads-management": typeof RootRootUserCustomerLeadsManagementRoute;
  "/root-user/dashboard/analytics": typeof RootRootUserDashboardAnalyticsRoute;
  "/root-user/dashboard/lead-analytics": typeof RootRootUserDashboardLeadAnalyticsRoute;
  "/root-user/organization/create-organization": typeof RootRootUserOrganizationCreateOrganizationRoute;
  "/root-user/settings/appearance": typeof RootRootUserSettingsAppearanceRoute;
  "/root-user/settings/profile": typeof RootRootUserSettingsProfileRoute;
  "/users/user/$id": typeof AuthenticatedUsersUserIdLazyRoute;
  "/root-user/dashboard": typeof RootRootUserDashboardIndexRoute;
  "/root-user/organization": typeof RootRootUserOrganizationIndexRoute;
  "/root-user/user": typeof RootRootUserUserIndexRoute;
  "/root-user/organization/organization/$id/detail": typeof RootRootUserOrganizationOrganizationIdDetailRoute;
  "/root-user/organization/organization/$id/update": typeof RootRootUserOrganizationOrganizationIdUpdateRoute;
}

export interface FileRoutesByTo {
  "": typeof RootRouteRouteWithChildren;
  "/500": typeof errors500LazyRoute;
  "/new-password": typeof authNewPasswordRoute;
  "/otp": typeof authOtpRoute;
  "/sign-in": typeof authSignInRoute;
  "/totp-setup": typeof authTotpSetupRoute;
  "/dashboard": typeof AuthenticatedDashboardRoute;
  "/settings": typeof AuthenticatedSettingsRouteLazyRouteWithChildren;
  "/forgot-password": typeof authForgotPasswordLazyRoute;
  "/sign-in-2": typeof authSignIn2LazyRoute;
  "/sign-up": typeof authSignUpLazyRoute;
  "/401": typeof errors401LazyRoute;
  "/403": typeof errors403LazyRoute;
  "/404": typeof errors404LazyRoute;
  "/503": typeof errors503LazyRoute;
  "/root-user/settings": typeof RootRootUserSettingsRouteRouteWithChildren;
  "/root-user/login": typeof rootRootUserLoginRoute;
  "/root-user/new-password": typeof rootRootUserNewPasswordRoute;
  "/root-user/otp": typeof rootRootUserOtpRoute;
  "/root-user/totp-setup": typeof rootRootUserTotpSetupRoute;
  "/root-user/audit": typeof RootRootUserAuditRoute;
  "/settings/account": typeof AuthenticatedSettingsAccountLazyRoute;
  "/settings/appearance": typeof AuthenticatedSettingsAppearanceLazyRoute;
  "/settings/display": typeof AuthenticatedSettingsDisplayLazyRoute;
  "/settings/notifications": typeof AuthenticatedSettingsNotificationsLazyRoute;
  "/settings/profile": typeof AuthenticatedSettingsProfileLazyRoute;
  "/users/create-user": typeof AuthenticatedUsersCreateUserLazyRoute;
  "/users": typeof AuthenticatedUsersIndexRoute;
  "/root-user": typeof RootRootUserIndexRoute;
  "/help-center": typeof AuthenticatedHelpCenterIndexLazyRoute;
  "/root-user/customer/contacts": typeof RootRootUserCustomerContactsRoute;
  "/root-user/customer/leads": typeof RootRootUserCustomerLeadsRoute;
  "/root-user/customer/leads-management": typeof RootRootUserCustomerLeadsManagementRoute;
  "/root-user/dashboard/analytics": typeof RootRootUserDashboardAnalyticsRoute;
  "/root-user/dashboard/lead-analytics": typeof RootRootUserDashboardLeadAnalyticsRoute;
  "/root-user/organization/create-organization": typeof RootRootUserOrganizationCreateOrganizationRoute;
  "/root-user/settings/appearance": typeof RootRootUserSettingsAppearanceRoute;
  "/root-user/settings/profile": typeof RootRootUserSettingsProfileRoute;
  "/users/user/$id": typeof AuthenticatedUsersUserIdLazyRoute;
  "/root-user/dashboard": typeof RootRootUserDashboardIndexRoute;
  "/root-user/organization": typeof RootRootUserOrganizationIndexRoute;
  "/root-user/user": typeof RootRootUserUserIndexRoute;
  "/root-user/organization/organization/$id/detail": typeof RootRootUserOrganizationOrganizationIdDetailRoute;
  "/root-user/organization/organization/$id/update": typeof RootRootUserOrganizationOrganizationIdUpdateRoute;
}

export interface FileRoutesById {
  __root__: typeof rootRoute;
  "/_authenticated": typeof AuthenticatedRouteRouteWithChildren;
  "/_root": typeof RootRouteRouteWithChildren;
  "/(auth)/500": typeof auth500Route;
  "/(auth)/new-password": typeof authNewPasswordRoute;
  "/(auth)/otp": typeof authOtpRoute;
  "/(auth)/sign-in": typeof authSignInRoute;
  "/(auth)/totp-setup": typeof authTotpSetupRoute;
  "/_authenticated/dashboard": typeof AuthenticatedDashboardRoute;
  "/_authenticated/settings": typeof AuthenticatedSettingsRouteLazyRouteWithChildren;
  "/(auth)/forgot-password": typeof authForgotPasswordLazyRoute;
  "/(auth)/sign-in-2": typeof authSignIn2LazyRoute;
  "/(auth)/sign-up": typeof authSignUpLazyRoute;
  "/(errors)/401": typeof errors401LazyRoute;
  "/(errors)/403": typeof errors403LazyRoute;
  "/(errors)/404": typeof errors404LazyRoute;
  "/(errors)/500": typeof errors500LazyRoute;
  "/(errors)/503": typeof errors503LazyRoute;
  "/_root/root-user/settings": typeof RootRootUserSettingsRouteRouteWithChildren;
  "/(root)/root-user/login": typeof rootRootUserLoginRoute;
  "/(root)/root-user/new-password": typeof rootRootUserNewPasswordRoute;
  "/(root)/root-user/otp": typeof rootRootUserOtpRoute;
  "/(root)/root-user/totp-setup": typeof rootRootUserTotpSetupRoute;
  "/_root/root-user/audit": typeof RootRootUserAuditRoute;
  "/_authenticated/settings/account": typeof AuthenticatedSettingsAccountLazyRoute;
  "/_authenticated/settings/appearance": typeof AuthenticatedSettingsAppearanceLazyRoute;
  "/_authenticated/settings/display": typeof AuthenticatedSettingsDisplayLazyRoute;
  "/_authenticated/settings/notifications": typeof AuthenticatedSettingsNotificationsLazyRoute;
  "/_authenticated/settings/profile": typeof AuthenticatedSettingsProfileLazyRoute;
  "/_authenticated/users/create-user": typeof AuthenticatedUsersCreateUserLazyRoute;
  "/_authenticated/users/": typeof AuthenticatedUsersIndexRoute;
  "/_root/root-user/": typeof RootRootUserIndexRoute;
  "/_authenticated/help-center/": typeof AuthenticatedHelpCenterIndexLazyRoute;
  "/_root/root-user/customer/contacts": typeof RootRootUserCustomerContactsRoute;
  "/_root/root-user/customer/leads": typeof RootRootUserCustomerLeadsRoute;
  "/_root/root-user/customer/leads-management": typeof RootRootUserCustomerLeadsManagementRoute;
  "/_root/root-user/dashboard/analytics": typeof RootRootUserDashboardAnalyticsRoute;
  "/_root/root-user/dashboard/lead-analytics": typeof RootRootUserDashboardLeadAnalyticsRoute;
  "/_root/root-user/organization/create-organization": typeof RootRootUserOrganizationCreateOrganizationRoute;
  "/_root/root-user/settings/appearance": typeof RootRootUserSettingsAppearanceRoute;
  "/_root/root-user/settings/profile": typeof RootRootUserSettingsProfileRoute;
  "/_authenticated/users/user/$id": typeof AuthenticatedUsersUserIdLazyRoute;
  "/_root/root-user/dashboard/": typeof RootRootUserDashboardIndexRoute;
  "/_root/root-user/organization/": typeof RootRootUserOrganizationIndexRoute;
  "/_root/root-user/user/": typeof RootRootUserUserIndexRoute;
  "/_root/root-user/organization/organization/$id/detail": typeof RootRootUserOrganizationOrganizationIdDetailRoute;
  "/_root/root-user/organization/organization/$id/update": typeof RootRootUserOrganizationOrganizationIdUpdateRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | ""
    | "/500"
    | "/new-password"
    | "/otp"
    | "/sign-in"
    | "/totp-setup"
    | "/dashboard"
    | "/settings"
    | "/forgot-password"
    | "/sign-in-2"
    | "/sign-up"
    | "/401"
    | "/403"
    | "/404"
    | "/503"
    | "/root-user/settings"
    | "/root-user/login"
    | "/root-user/new-password"
    | "/root-user/otp"
    | "/root-user/totp-setup"
    | "/root-user/audit"
    | "/settings/account"
    | "/settings/appearance"
    | "/settings/display"
    | "/settings/notifications"
    | "/settings/profile"
    | "/users/create-user"
    | "/users"
    | "/root-user"
    | "/help-center"
    | "/root-user/customer/contacts"
    | "/root-user/customer/leads"
    | "/root-user/customer/leads-management"
    | "/root-user/dashboard/analytics"
    | "/root-user/dashboard/lead-analytics"
    | "/root-user/organization/create-organization"
    | "/root-user/settings/appearance"
    | "/root-user/settings/profile"
    | "/users/user/$id"
    | "/root-user/dashboard"
    | "/root-user/organization"
    | "/root-user/user"
    | "/root-user/organization/organization/$id/detail"
    | "/root-user/organization/organization/$id/update";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | ""
    | "/500"
    | "/new-password"
    | "/otp"
    | "/sign-in"
    | "/totp-setup"
    | "/dashboard"
    | "/settings"
    | "/forgot-password"
    | "/sign-in-2"
    | "/sign-up"
    | "/401"
    | "/403"
    | "/404"
    | "/503"
    | "/root-user/settings"
    | "/root-user/login"
    | "/root-user/new-password"
    | "/root-user/otp"
    | "/root-user/totp-setup"
    | "/root-user/audit"
    | "/settings/account"
    | "/settings/appearance"
    | "/settings/display"
    | "/settings/notifications"
    | "/settings/profile"
    | "/users/create-user"
    | "/users"
    | "/root-user"
    | "/help-center"
    | "/root-user/customer/contacts"
    | "/root-user/customer/leads"
    | "/root-user/customer/leads-management"
    | "/root-user/dashboard/analytics"
    | "/root-user/dashboard/lead-analytics"
    | "/root-user/organization/create-organization"
    | "/root-user/settings/appearance"
    | "/root-user/settings/profile"
    | "/users/user/$id"
    | "/root-user/dashboard"
    | "/root-user/organization"
    | "/root-user/user"
    | "/root-user/organization/organization/$id/detail"
    | "/root-user/organization/organization/$id/update";
  id:
    | "__root__"
    | "/_authenticated"
    | "/_root"
    | "/(auth)/500"
    | "/(auth)/new-password"
    | "/(auth)/otp"
    | "/(auth)/sign-in"
    | "/(auth)/totp-setup"
    | "/_authenticated/dashboard"
    | "/_authenticated/settings"
    | "/(auth)/forgot-password"
    | "/(auth)/sign-in-2"
    | "/(auth)/sign-up"
    | "/(errors)/401"
    | "/(errors)/403"
    | "/(errors)/404"
    | "/(errors)/500"
    | "/(errors)/503"
    | "/_root/root-user/settings"
    | "/(root)/root-user/login"
    | "/(root)/root-user/new-password"
    | "/(root)/root-user/otp"
    | "/(root)/root-user/totp-setup"
    | "/_root/root-user/audit"
    | "/_authenticated/settings/account"
    | "/_authenticated/settings/appearance"
    | "/_authenticated/settings/display"
    | "/_authenticated/settings/notifications"
    | "/_authenticated/settings/profile"
    | "/_authenticated/users/create-user"
    | "/_authenticated/users/"
    | "/_root/root-user/"
    | "/_authenticated/help-center/"
    | "/_root/root-user/customer/contacts"
    | "/_root/root-user/customer/leads"
    | "/_root/root-user/customer/leads-management"
    | "/_root/root-user/dashboard/analytics"
    | "/_root/root-user/dashboard/lead-analytics"
    | "/_root/root-user/organization/create-organization"
    | "/_root/root-user/settings/appearance"
    | "/_root/root-user/settings/profile"
    | "/_authenticated/users/user/$id"
    | "/_root/root-user/dashboard/"
    | "/_root/root-user/organization/"
    | "/_root/root-user/user/"
    | "/_root/root-user/organization/organization/$id/detail"
    | "/_root/root-user/organization/organization/$id/update";
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren;
  RootRouteRoute: typeof RootRouteRouteWithChildren;
  auth500Route: typeof auth500Route;
  authNewPasswordRoute: typeof authNewPasswordRoute;
  authOtpRoute: typeof authOtpRoute;
  authSignInRoute: typeof authSignInRoute;
  authTotpSetupRoute: typeof authTotpSetupRoute;
  authForgotPasswordLazyRoute: typeof authForgotPasswordLazyRoute;
  authSignIn2LazyRoute: typeof authSignIn2LazyRoute;
  authSignUpLazyRoute: typeof authSignUpLazyRoute;
  errors401LazyRoute: typeof errors401LazyRoute;
  errors403LazyRoute: typeof errors403LazyRoute;
  errors404LazyRoute: typeof errors404LazyRoute;
  errors500LazyRoute: typeof errors500LazyRoute;
  errors503LazyRoute: typeof errors503LazyRoute;
  rootRootUserLoginRoute: typeof rootRootUserLoginRoute;
  rootRootUserNewPasswordRoute: typeof rootRootUserNewPasswordRoute;
  rootRootUserOtpRoute: typeof rootRootUserOtpRoute;
  rootRootUserTotpSetupRoute: typeof rootRootUserTotpSetupRoute;
}

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  RootRouteRoute: RootRouteRouteWithChildren,
  auth500Route: auth500Route,
  authNewPasswordRoute: authNewPasswordRoute,
  authOtpRoute: authOtpRoute,
  authSignInRoute: authSignInRoute,
  authTotpSetupRoute: authTotpSetupRoute,
  authForgotPasswordLazyRoute: authForgotPasswordLazyRoute,
  authSignIn2LazyRoute: authSignIn2LazyRoute,
  authSignUpLazyRoute: authSignUpLazyRoute,
  errors401LazyRoute: errors401LazyRoute,
  errors403LazyRoute: errors403LazyRoute,
  errors404LazyRoute: errors404LazyRoute,
  errors500LazyRoute: errors500LazyRoute,
  errors503LazyRoute: errors503LazyRoute,
  rootRootUserLoginRoute: rootRootUserLoginRoute,
  rootRootUserNewPasswordRoute: rootRootUserNewPasswordRoute,
  rootRootUserOtpRoute: rootRootUserOtpRoute,
  rootRootUserTotpSetupRoute: rootRootUserTotpSetupRoute,
};

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_authenticated",
        "/_root",
        "/(auth)/500",
        "/(auth)/new-password",
        "/(auth)/otp",
        "/(auth)/sign-in",
        "/(auth)/totp-setup",
        "/(auth)/forgot-password",
        "/(auth)/sign-in-2",
        "/(auth)/sign-up",
        "/(errors)/401",
        "/(errors)/403",
        "/(errors)/404",
        "/(errors)/500",
        "/(errors)/503",
        "/(root)/root-user/login",
        "/(root)/root-user/new-password",
        "/(root)/root-user/otp",
        "/(root)/root-user/totp-setup"
      ]
    },
    "/_authenticated": {
      "filePath": "_authenticated/route.tsx",
      "children": [
        "/_authenticated/dashboard",
        "/_authenticated/settings",
        "/_authenticated/users/create-user",
        "/_authenticated/users/",
        "/_authenticated/help-center/",
        "/_authenticated/users/user/$id"
      ]
    },
    "/_root": {
      "filePath": "_root/route.tsx",
      "children": [
        "/_root/root-user/settings",
        "/_root/root-user/audit",
        "/_root/root-user/",
        "/_root/root-user/customer/contacts",
        "/_root/root-user/customer/leads",
        "/_root/root-user/customer/leads-management",
        "/_root/root-user/dashboard/analytics",
        "/_root/root-user/dashboard/lead-analytics",
        "/_root/root-user/organization/create-organization",
        "/_root/root-user/dashboard/",
        "/_root/root-user/organization/",
        "/_root/root-user/user/",
        "/_root/root-user/organization/organization/$id/detail",
        "/_root/root-user/organization/organization/$id/update"
      ]
    },
    "/(auth)/500": {
      "filePath": "(auth)/500.tsx"
    },
    "/(auth)/new-password": {
      "filePath": "(auth)/new-password.tsx"
    },
    "/(auth)/otp": {
      "filePath": "(auth)/otp.tsx"
    },
    "/(auth)/sign-in": {
      "filePath": "(auth)/sign-in.tsx"
    },
    "/(auth)/totp-setup": {
      "filePath": "(auth)/totp-setup.tsx"
    },
    "/_authenticated/dashboard": {
      "filePath": "_authenticated/dashboard.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/settings": {
      "filePath": "_authenticated/settings/route.lazy.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/settings/account",
        "/_authenticated/settings/appearance",
        "/_authenticated/settings/display",
        "/_authenticated/settings/notifications",
        "/_authenticated/settings/profile"
      ]
    },
    "/(auth)/forgot-password": {
      "filePath": "(auth)/forgot-password.lazy.tsx"
    },
    "/(auth)/sign-in-2": {
      "filePath": "(auth)/sign-in-2.lazy.tsx"
    },
    "/(auth)/sign-up": {
      "filePath": "(auth)/sign-up.lazy.tsx"
    },
    "/(errors)/401": {
      "filePath": "(errors)/401.lazy.tsx"
    },
    "/(errors)/403": {
      "filePath": "(errors)/403.lazy.tsx"
    },
    "/(errors)/404": {
      "filePath": "(errors)/404.lazy.tsx"
    },
    "/(errors)/500": {
      "filePath": "(errors)/500.lazy.tsx"
    },
    "/(errors)/503": {
      "filePath": "(errors)/503.lazy.tsx"
    },
    "/_root/root-user/settings": {
      "filePath": "_root/root-user/settings/route.tsx",
      "parent": "/_root",
      "children": [
        "/_root/root-user/settings/appearance",
        "/_root/root-user/settings/profile"
      ]
    },
    "/(root)/root-user/login": {
      "filePath": "(root)/root-user/login.tsx"
    },
    "/(root)/root-user/new-password": {
      "filePath": "(root)/root-user/new-password.tsx"
    },
    "/(root)/root-user/otp": {
      "filePath": "(root)/root-user/otp.tsx"
    },
    "/(root)/root-user/totp-setup": {
      "filePath": "(root)/root-user/totp-setup.tsx"
    },
    "/_root/root-user/audit": {
      "filePath": "_root/root-user/audit.tsx",
      "parent": "/_root"
    },
    "/_authenticated/settings/account": {
      "filePath": "_authenticated/settings/account.lazy.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/settings/appearance": {
      "filePath": "_authenticated/settings/appearance.lazy.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/settings/display": {
      "filePath": "_authenticated/settings/display.lazy.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/settings/notifications": {
      "filePath": "_authenticated/settings/notifications.lazy.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/settings/profile": {
      "filePath": "_authenticated/settings/profile.lazy.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/users/create-user": {
      "filePath": "_authenticated/users/create-user.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/users/": {
      "filePath": "_authenticated/users/index.tsx",
      "parent": "/_authenticated"
    },
    "/_root/root-user/": {
      "filePath": "_root/root-user/index.tsx",
      "parent": "/_root"
    },
    "/_authenticated/help-center/": {
      "filePath": "_authenticated/help-center/index.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_root/root-user/customer/contacts": {
      "filePath": "_root/root-user/customer/contacts.tsx",
      "parent": "/_root"
    },
    "/_root/root-user/customer/leads": {
      "filePath": "_root/root-user/customer/leads.tsx",
      "parent": "/_root"
    },
    "/_root/root-user/customer/leads-management": {
      "filePath": "_root/root-user/customer/leads-management.tsx",
      "parent": "/_root"
    },
    "/_root/root-user/dashboard/analytics": {
      "filePath": "_root/root-user/dashboard/analytics.tsx",
      "parent": "/_root"
    },
    "/_root/root-user/dashboard/lead-analytics": {
      "filePath": "_root/root-user/dashboard/lead-analytics.tsx",
      "parent": "/_root"
    },
    "/_root/root-user/organization/create-organization": {
      "filePath": "_root/root-user/organization/create-organization.tsx",
      "parent": "/_root"
    },
    "/_root/root-user/settings/appearance": {
      "filePath": "_root/root-user/settings/appearance.tsx",
      "parent": "/_root/root-user/settings"
    },
    "/_root/root-user/settings/profile": {
      "filePath": "_root/root-user/settings/profile.tsx",
      "parent": "/_root/root-user/settings"
    },
    "/_authenticated/users/user/$id": {
      "filePath": "_authenticated/users/user.$id.lazy.tsx",
      "parent": "/_authenticated"
    },
    "/_root/root-user/dashboard/": {
      "filePath": "_root/root-user/dashboard/index.tsx",
      "parent": "/_root"
    },
    "/_root/root-user/organization/": {
      "filePath": "_root/root-user/organization/index.tsx",
      "parent": "/_root"
    },
    "/_root/root-user/user/": {
      "filePath": "_root/root-user/user/index.tsx",
      "parent": "/_root"
    },
    "/_root/root-user/organization/organization/$id/detail": {
      "filePath": "_root/root-user/organization/organization.$id.detail.tsx",
      "parent": "/_root"
    },
    "/_root/root-user/organization/organization/$id/update": {
      "filePath": "_root/root-user/organization/organization.$id.update.tsx",
      "parent": "/_root"
    }
  }
}
ROUTE_MANIFEST_END */
